import { useRoute } from '#imports'

export function useIsWebview() {
  const route = useRoute()

  return Boolean(route.meta?.isWebview)
}
